var map = {
	"./Pattern01.png": "a3ee",
	"./Pattern02.png": "1c17",
	"./Pattern03.png": "d390",
	"./Pattern04.png": "3182",
	"./Pattern05.png": "c75c",
	"./Pattern06.png": "7fcc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1595";